import { render, staticRenderFns } from "./TaskChatForm.vue?vue&type=template&id=7720e6cc&"
import script from "./TaskChatForm.vue?vue&type=script&lang=ts&"
export * from "./TaskChatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports